import React from 'react';
import { MapContainer, TileLayer, Marker, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import icon from '../assets/img/webp/marker.webp';

function Maps() {
  const position = [44.887150, 6.636400];

  let DefaultIcon = L.icon({
    iconUrl: icon,
    iconSize: [80, 80],
    iconAnchor: [40, 30]
  });

  L.Marker.prototype.options.icon = DefaultIcon;

  return (
    <div className='map-container'>
      <MapContainer
        center={position}
        zoom={18}
        style={{ height: '400px', width: '100%' }}
        zoomControl={false}
        scrollWheelZoom={false}
        dragging={!L.Browser.mobile}
        tap={!L.Browser.mobile}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position}></Marker>
        <ZoomControl position="topright" />
      </MapContainer>
    </div>
  );
}

export default Maps;
